export default function getGtagClientId(gtagClientId) {
  return new Promise((resolve) => {
    if (!window.gtag || !gtagClientId) resolve(null);
    window.gtag('get', gtagClientId, 'client_id', resolve);
  });
}
